







































































































import Vue from 'vue';
import store from '../store/store';
import _ from 'lodash';
import 'intro.js/introjs.css';
import {
  mapState,
  mapActions
} from 'vuex';
import {
  HeaderData
} from '../types/common';
import introJs from 'intro.js';

declare var _hmt: any;

export default Vue.extend({
  name: 'Header',
  data(): HeaderData {
    return {
      isShowDetail: false,
      isShowIp: false,
      title: 'IP范围',
      isShowVersion: false,
      version: {
        features: '',
        versionNo: '',
        updateTime: ''
      }
    };
  },
  computed: mapState({
    userInfo: (state: any) => store.getters.getUserInfo,
    menuIndex: (state: any) => store.getters.getMenuIndex,
    checkHomeUrl: (state: any) => store.getters.getCheckHomeUrl,
    logoutUrl: (state: any) => store.getters.getLogoutUrl,
    paperType: (state: any) => store.getters.getPaperType,
    checkType: (state: any) => store.getters.getCheckType
  }),
  methods: {
    // 跳转检测首页
    toCheckHome() {
      window.location.href = this.checkHomeUrl;
    },
    // 引导页
    help() {
      this.$store.dispatch('setIntro', true);
      // 事件追踪start
      _hmt.push(['_trackEvent', '引导', '帮助引导', '事件价值', 1]);
      // end
      const introOptions: any = {
        prevLabel: '上一步',
        nextLabel: '下一步',
        skipLabel: '跳过',
        doneLabel: '结束',
        disableInteraction: true
      };
      if (this.menuIndex === 'paperCheck') {
        if (this.paperType === 'newPaper') {
          if (this.checkType === 'upload') {
            introOptions.steps = [{
              element: '#paperCheck-step1',
              intro: '您正在使用的是“新文献检测”功能，点击右侧页签可切换至“已发表文献检测”功能。'
            }, {
              element: '#paperCheck-step2 .el-tabs__nav',
              intro: '页面默认为您提供本地上传功能以提交送检文献，您也可以切换至手工录入功能通过手工填写与粘贴来送检文献。'
            }, {
              element: '#newPaper .webuploader-pick',
              intro: '点击“上传文档”按钮添加要送检的本地文献。当您需要送检某本地文件夹中全部文档时，可使用CTRL+A快捷键选中全部。'
            }, {
              element: '#paperCheck-step4',
              intro: '系统还为您提供两项附加功能：送检繁体文献与保存至文件夹。您不需要使用此两项功能则无需点击开关图标，不使用附加功能不影响正常检测流程。'
            }, {
              element: '#paperCheck-step5', 
              intro: '仔细阅读温馨提示内容可帮助您更好地完成送检，确认了解内容后可收起温馨提示框。'
            }, {
              element: '#paperCheck-step6',
              intro: '文件上传列表会呈现您已上传的文件信息，您还可以单篇或批量删除已上传的文件，或下载原文核查内容。'
            }, {
              element: '#paperCheck-step7',
              intro: '成功上传您要送检的文献后，点击“开始检测”即可向系统提交检测任务。提交成功后系统将弹出提示，您可以停留在当前页面继续检测，也可以前往检测信息页面查看检测结果。'
            }];
          } else {
            introOptions.steps = [{
              element: '#paperCheck-step1',
              intro: '您正在使用的是“新文献检测”功能，点击右侧页签可切换至“已发表文献检测”功能。'
            }, {
              element: '#paperCheck-step2 .el-tabs__nav',
              intro: '页面默认为您提供本地上传功能以提交送检文献，您也可以切换至手工录入功能通过手工填写与粘贴来送检文献。'
            }, {
              element: '#paperCheck-step8',
              intro: '系统还为您提供两项附加功能：送检繁体文献与保存至文件夹。您不需要使用此两项功能则无需点击开关图标，不使用附加功能不影响正常检测流程。'
            }, {
              element: '#paperCheck-step9',
              intro: '请输入题名、作者与文本内容，其中题名与文本内容为必填，作者可选填。系统建议您填写作者信息，可用于识别自引相似比。'
            }, {
              element: '#paperCheck-step10',
              intro: '点击【清空】可清除题名、作者及文本内容输入框中全部已填写内容，方便您重新输入。'
            }, {
              element: '#paperCheck-step11',
              intro: '成功录入您要送检的文献后，点击“开始检测”即可向系统提交检测任务。提交成功后系统将弹出提示，您可以停留在当前页面继续检测，也可以前往检测信息页面查看检测结果。'
            }];
          }
        } else if (this.paperType === 'publish') {
          if (this.checkType === 'upload') {
            introOptions.steps = [{
              element: '#paperCheck-step1',
              intro: '您正在使用的是“已发表文献检测”功能，点击左侧页签可切换至“新文献检测”功能。'
            }, {
              element: '#paperCheck-step2 .el-tabs__nav',
              intro: '页面默认为您提供本地上传功能以提交送检文献，您也可以切换至手工录入功能通过手工填写与粘贴来送检文献。'
            }, {
              element: '#paperCheck-step4',
              intro: '系统还为您提供两项附加功能：送检繁体文献与保存至文件夹。您不需要使用此两项功能则无需点击开关图标，不使用附加功能不影响正常检测流程。'
            }, {
              element: '#paperCheck-step5',
              intro: '点击“选择文件”按钮可选择一篇本地文件上传，作者信息非必填，但若无作者信息，系统无法有效识别自引。建议您上传仔细阅读温馨提示内容以便顺利送检。'
            }, {
              element: '#paperCheck-step6',
              intro: '进行已发表文献检测需要填写收稿时间（无收稿时间时可填写发表时间），检测时送检文献将与收稿时间之前的全部比对库文献进行比对，以精准实现文献内容创新性检测。'
            }, {
              element: '#paperCheck-step7',
              intro: '成功上传您要送检的文献后，点击“开始检测”即可向系统提交检测任务。提交成功后系统将弹出提示，您可以停留在当前页面继续检测，也可以前往检测信息页面查看检测结果。'
            }];
          } else {
            introOptions.steps = [{
              element: '#paperCheck-step1',
              intro: '您正在使用的是“已发表文献检测”功能，点击左侧页签可切换至“新文献检测”功能。'
            }, {
              element: '#paperCheck-step2 .el-tabs__nav',
              intro: '页面默认为您提供本地上传功能以提交送检文献，您也可以切换至手工录入功能通过手工填写与粘贴来送检文献。'
            }, {
              element: '#paperCheck-step8',
              intro: '系统还为您提供两项附加功能：送检繁体文献与保存至文件夹。您不需要使用此两项功能则无需点击开关图标，不使用附加功能不影响正常检测流程。'
            }, {
              element: '#paperCheck-step9',
              intro: '请输入题名、作者与文本内容，其中题名与文本内容为必填，作者可选填。系统建议您填写作者信息，可用于识别自引相似比。'
            }, {
              element: '#paperCheck-step6',
              intro: '进行已发表文献检测需要填写收稿时间（无收稿时间时可填写发表时间），检测时送检文献将与收稿时间之前的全部比对库文献进行比对，以精准实现文献内容创新性检测。'
            }, {
              element: '#paperCheck-step10',
              intro: '点击【清空】可清除题名、作者及文本内容输入框中全部已填写内容，方便您重新输入。'
            }, {
              element: '#paperCheck-step11',
              intro: '成功录入您要送检的文献后，点击“开始检测”即可向系统提交检测任务。提交成功后系统将弹出提示，您可以停留在当前页面继续检测，也可以前往检测信息页面查看检测结果。'
            }];
          }
        }
      }
      this.$nextTick(() => {
        introJs().setOptions(introOptions).onchange((a) => {
          // 提示排序的时候，需要展开
          // console.log(123);
        }).oncomplete(() => {
            // 点击跳过按钮后执行的事件
            // console.log('complete');
        }).onexit(() => {
            // 点击结束按钮后， 执行的事件
            // console.log('exit');
            this.$store.dispatch('setIntro', false);
        }).start();
      });
    },
    // ip详情
    ipDetail(mark: boolean, title: string) {
      this.isShowIp = mark;
      this.title = title;
    },
    // 版本详情
    versionDetail(mark: boolean) {
      this.isShowVersion = mark;
    },
    getVersion() {
      this.$http.get('/api/System/Version').then((data: any) => {
        this.version = data.result;
      });
    },
    // 退出登录
    signOut() {
      window.location.href = this.logoutUrl;
    }
  },
  mounted() {
      this.getVersion();
  }
});
